(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["essi-cart-drawer"] && !Shopify.designMode) return;
  try {
    (function(){
  if(window.EssiCartDrawer && window.EssiCartDrawer.__ready) return;
  var drawer=document.querySelector('[data-essi-cart-drawer]');
  var overlay=document.querySelector('[data-essi-cart-overlay]');
  if(!drawer || !overlay) return;
  var itemsWrap=drawer.querySelector('[data-essi-cart-items]');
  var titleEl=drawer.querySelector('[data-essi-cart-title]');
  var subtotalEl=drawer.querySelector('[data-essi-cart-subtotal]');
  var shippingText=drawer.querySelector('[data-essi-cart-shipping-text]');
  var shippingPriceEl=drawer.querySelector('[data-essi-cart-shipping-price]');
  var estimatedTotalEl=drawer.querySelector('[data-essi-cart-estimated-total]');
  var timerEl=drawer.querySelector('[data-essi-cart-timer]');
  var smartOfferEl=drawer.querySelector('[data-essi-cart-smart-offer]');
  // Keep a dismissed offer hidden while viewing the same tier; show a NEW tier if selected.
  var dismissedUpsellOfferKey=null;
  var checkoutEl=drawer.querySelector('[data-essi-cart-checkout]');
  var ageCheckEl=drawer.querySelector('[data-essi-age-check]');
  var ageErrorEl=drawer.querySelector('[data-essi-age-error]');
  var FREE_SHIP_CENTS=0;
  var STANDARD_SHIPPING_CENTS=0;
  var timerId=null;
  // ESSI header bag: live quantity badge, without changing any cart offers or prices.
  function updateHeaderCartBadge(cart){
    var links=document.querySelectorAll('.eao-header a[data-essi-cart-open]');
    if(!links.length || !cart) return;
    var count=Math.max(0,Number(cart.item_count)||0);
    links.forEach(function(link){
      link.classList.add('essi-header-cart-link');
      var badge=link.querySelector('.essi-header-cart-badge');
      if(!badge){
        badge=document.createElement('span');
        badge.className='essi-header-cart-badge';
        badge.setAttribute('aria-hidden','true');
        badge.hidden=true;
        link.appendChild(badge);
      }
      badge.textContent=count>99?'99+':String(count);
      badge.hidden=(count===0);
      link.setAttribute('aria-label',count===0 ? 'Cart, empty' : 'Cart, '+count+' items');
    });
  }
  function refreshHeaderCartBadge(){
    return loadCartRaw().then(updateHeaderCartBadge).catch(function(){
      // Keep last known badge if the network is temporarily unavailable.
    });
  }
  function rootPath(){
    return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  }
  function escapeHtml(value){
    return String(value == null ? '' : value)
      .replace(/&/g,'&amp;')
      .replace(/</g,'&lt;')
      .replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;')
      .replace(/'/g,'&#039;');
  }
  function money(cents){
    var currency=(window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : 'USD';
    try{
      return new Intl.NumberFormat('en-US',{
        style:'currency',
        currency:currency,
        minimumFractionDigits:2,
        maximumFractionDigits:2
      }).format((Number(cents)||0)/100);
    }catch(e){
      return '$'+((Number(cents)||0)/100).toFixed(2);
    }
  }
  function itemImage(item){
    var url='';
    if(item && item.featured_image && item.featured_image.url) url=item.featured_image.url;
    else if(item && item.image) url=item.image;
    if(!url) return '';
    if(url.indexOf('//')===0) url='https:'+url;
    return url;
  }
  function offerProperty(item){
    if(!item || !item.properties) return '';
    return item.properties['_Essi offer'] || item.properties['Essi offer'] || '';
  }
  function itemSellingPlanId(item){
    if(!item || !item.selling_plan_allocation || !item.selling_plan_allocation.selling_plan) return 0;
    return Number(item.selling_plan_allocation.selling_plan.id)||0;
  }
  function isSubscriptionItem(item){
    return itemSellingPlanId(item)>0;
  }
  function subscriptionPlanName(item){
    if(!item || !item.selling_plan_allocation || !item.selling_plan_allocation.selling_plan) return '';
    return String(item.selling_plan_allocation.selling_plan.name||'');
  }
  function subscriptionFrequencyLabel(item){
    var name=subscriptionPlanName(item);
    if(!name) return 'Recurring delivery';
    var match=name.match(/(\d+)\s*week/i);
    if(match){
      var weeks=parseInt(match[1],10);
      return weeks===1 ? 'Every week' : 'Every '+weeks+' weeks';
    }
    if(/every\s+week/i.test(name) || /weekly/i.test(name)) return 'Every week';
    return name;
  }
  function cartHasSubscription(cart){
    return !!(cart && Array.isArray(cart.items) && cart.items.some(isSubscriptionItem));
  }
  // Build ESSI-2149-915-20261022-V3 — no old $51.03 / $56.70 assumptions.
  var UPGRADE_DISCOUNT_CODE='UPGRADE10';
  var BUNDLE3_DISCOUNT_CODE='BUNDLE3X9';
  // Preserve the normal BUNDLE3X9 $3 saving for 3+3 ($64.47 -> $61.47
  // when the ESSI one-time unit price is $21.49).
  // An accepted one-tap upgrade REPLACES that discount code with BUNDLE3UP270:
  // $3 original saving + 10% of the saved $3-off bundle price.
  // At $21.49 each: $3.00 + $6.15 = $9.15 combined fixed discount used ONCE per order.
  // Configure BUNDLE3UP270 to exactly $9.15 in Shopify Discounts.
  // This code models a percentage at the CURRENT base price. If the catalog
  // price changes, update this fixed Shopify discount or use Shopify Functions.
  var BUNDLE3_UPGRADE_DISCOUNT_CODE='BUNDLE3UP270';
  // Match the ACTIVE Shopify Discounts settings; cents, USD.
  // BUNDLE3UP270: Amount off ORDER $9.15, minimum purchase $55,
  // one-time purchase only. This replaces BUNDLE3X9 for an accepted 3+3 upgrade.
  // IMPORTANT: storefront rules cannot stop someone entering a copied code
  // directly in Shopify checkout. Eligibility must also be enforced by Shopify.
  var BUNDLE3_CHECKOUT_MIN_CENTS=5500;
  var BUNDLE3_UPGRADE_DISCOUNT_CENTS=915;
  var BUNDLE3_EXPECTED_UNIT_CENTS=2149;
  var upgradeInProgress=false;
  var BUNDLE3_NORMAL_DISCOUNT_CENTS=300;
  function bundle3NormalPriceCents(unitCents){
    return Math.max(0,(Number(unitCents)||0)*3-BUNDLE3_NORMAL_DISCOUNT_CENTS);
  }
  function bundle3UpgradedPriceCents(unitCents){
    // Actual FIXED Shopify code, not a simulated percent off the frontend.
    return Math.max(0,(Number(unitCents)||0)*3-BUNDLE3_UPGRADE_DISCOUNT_CENTS);
  }
  // Shopify can allocate a percentage order discount across eligible lines
  // and round by line. Its final cents may differ from a single Math.round
  // applied to the whole bundle; the storefront estimates conservatively.
  function estimatedPercentUpgradeCents(bundleCents){
    var before=Math.max(0,Math.round(Number(bundleCents)||0));
    // Observed on this shop: $85.96 with UPGRADE10 becomes $77.37.
    // Floor the estimated discount and always trust verified cart.total_price.
    return before-Math.floor(before*10/100);
  }
  function upgradeCartPriceMatchesShopify(tier,unitCents,actualCents){
    var unit=Number(unitCents)||0;
    var actual=Number(actualCents);
    if(!tier || !Number.isFinite(actual) || actual<0 || unit<=0) return false;
    if(tier.key==='3+3') {
      // The $9.15 fixed code must be exact — no percentage-rounding tolerance.
      return actual===bundle3UpgradedPriceCents(unit);
    }
    var expected=estimatedPercentUpgradeCents(unit*tier.buy);
    // Allow at most one cent for Shopify's per-line percentage allocation.
    // This NEVER allows an absent 10% discount or a wrong bundle quantity.
    return Math.abs(actual-expected)<=1;
  }
  function bundle3UpgradeConfigValid(unitCents){
    // If the catalog price changes, pause only this special upgrade instead
    // of advertising a 10% discount that no longer equals the Shopify code.
    var unit=Number(unitCents)||0;
    var regular=bundle3NormalPriceCents(unit);
    var upgraded=bundle3UpgradedPriceCents(unit);
    return unit===BUNDLE3_EXPECTED_UNIT_CENTS &&
      unit*3>=BUNDLE3_CHECKOUT_MIN_CENTS &&
      regular-upgraded===Math.round(regular*.10);
  }
  var ESSI_BUNDLE_TIERS=[
    {key:'2+1',name:'BUY 2 + GET 1 FREE',property:'Buy 2, Get 1 Free',total:3,buy:2,free:1},
    {key:'3+3',name:'BUY 3 + GET 3 FREE',property:'Buy 3, Get 3 Free',total:6,buy:3,free:3},
    {key:'4+5',name:'BUY 4 + GET 5 FREE',property:'Buy 4, Get 5 Free',total:9,buy:4,free:5},
    {key:'5+7',name:'BUY 5 + GET 7 FREE',property:'Buy 5, Get 7 Free',total:12,buy:5,free:7}
  ];
  function normalizeOffer(value){
    return String(value||'')
      .toLowerCase()
      .replace(/[,+]/g,' ')
      .replace(/\s+/g,' ')
      .trim();
  }
  function offerMatchesTier(offer,tier){
    var text=normalizeOffer(offer);
    if(!text) return false;
    var compact=text.replace(/\s/g,'');
    if(compact.indexOf(tier.key)!==-1) return true;
    return (
      text.indexOf('buy '+tier.buy)!==-1 &&
      text.indexOf('get '+tier.free)!==-1
    );
  }
  function bundleTierForItem(item){
    var offer=offerProperty(item);
    for(var i=0;i<ESSI_BUNDLE_TIERS.length;i++){
      if(offerMatchesTier(offer,ESSI_BUNDLE_TIERS[i])){
        return ESSI_BUNDLE_TIERS[i];
      }
    }
    return null;
  }
  function currentBundleIndex(cart){
    var best=-1;
    if(!cart || !cart.items) return best;
    cart.items.forEach(function(item){
      var offer=offerProperty(item);
      ESSI_BUNDLE_TIERS.forEach(function(tier,index){
        if(offerMatchesTier(offer,tier) && index>best){
          best=index;
        }
      });
    });
    return best;
  }
  function isSingleEssiItem(item){
    var offer=offerProperty(item);
    return (
      offer==='1 Device' ||
      offer==='1 ESSI' ||
      offer==='Try 1 Essi' ||
      offer==='TRY 1 ESSI'
    );
  }
  function isEssiOfferItem(item){
    if(isSingleEssiItem(item) || !!bundleTierForItem(item)) return true;
    var offer=offerProperty(item);
    if(isSubscriptionItem(item) && /essi/i.test(String(offer||''))) return true;
    return false;
  }
  function getUnitCents(cart){
    if(!cart || !cart.items) return 0;
    for(var i=0;i<cart.items.length;i++){
      var item=cart.items[i];
      if(!isEssiOfferItem(item)) continue;
      var unit=
        Number(item.original_price) ||
        Number(item.price) ||
        Number(item.final_price) ||
        0;
      if(unit>0) return unit;
    }
    return 0;
  }
  function cartUpsellKey(cart){
    var token=(cart && cart.token) ? String(cart.token) : 'default';
    return 'essiUpsellAccepted:'+token;
  }
  function upsellWasAccepted(cart){
    if(cartHasUpgradeMarker(cart)) return true;
    try{
      return localStorage.getItem(cartUpsellKey(cart))==='1';
    }catch(e){
      return false;
    }
  }
  function markUpsellAccepted(cart){
    try{
      localStorage.setItem(cartUpsellKey(cart),'1');
    }catch(e){}
  }
  function clearUpsellAccepted(cart){
    try{
      localStorage.removeItem(cartUpsellKey(cart));
    }catch(e){}
  }
  function cartHasUpgradeMarker(cart){
    if(!cart || !Array.isArray(cart.items)) return false;
    for(var i=0;i<cart.items.length;i++){
      var item=cart.items[i] || {};
      var props=item.properties || {};
      if(String(props['_Essi upgraded'] || '')==='1'){
        return true;
      }
    }
    return false;
  }
  function itemHasUpgradeMarker(item){
    if(!item || !item.properties) return false;
    return String(item.properties['_Essi upgraded'] || '')==='1';
  }
  function cartHasDiscountCode(cart,code){
    var target=String(code||'').toLowerCase();
    if(!target || !cart) return false;
    if(Array.isArray(cart.discount_codes)){
      for(var i=0;i<cart.discount_codes.length;i++){
        var dc=cart.discount_codes[i] || {};
        if(dc.applicable!==false && String(dc.code || dc.title || '').toLowerCase()===target){
          return true;
        }
      }
    }
    if(Array.isArray(cart.cart_level_discount_applications)){
      for(var j=0;j<cart.cart_level_discount_applications.length;j++){
        var app=cart.cart_level_discount_applications[j] || {};
        if(String(app.title || app.code || '').toLowerCase()===target){
          return true;
        }
      }
    }
    if(Array.isArray(cart.items)){
      for(var k=0;k<cart.items.length;k++){
        var item=cart.items[k] || {};
        var allocations=item.line_level_discount_allocations || [];
        for(var a=0;a<allocations.length;a++){
          var allocation=allocations[a] || {};
          var application=allocation.discount_application || {};
          if(String(application.title || application.code || '').toLowerCase()===target){
            return true;
          }
        }
      }
    }
    return false;
  }
  function cartHasAnyEssiUpgradeDiscount(cart){
    return cartHasDiscountCode(cart,UPGRADE_DISCOUNT_CODE) ||
      cartHasDiscountCode(cart,BUNDLE3_UPGRADE_DISCOUNT_CODE);
  }
  function upgradedCartStateIsValid(cart){
    if(!cart || !Array.isArray(cart.items) || !cart.items.length) return false;
    var marked=cart.items.filter(function(item){
      return itemHasUpgradeMarker(item);
    });
    if(!marked.length) return false;
    /*
      Shopify can split one BOGO bundle into multiple cart lines (for example
      2 paid + 1 free). That is still ONE valid ESSI offer. Validate the
      combined quantity/properties instead of requiring exactly one line.
    */
    var first=marked[0];
    var tier=bundleTierForItem(first);
    if(!tier) return false;
    var productId=Number(first.product_id)||0;
    var variantId=Number(first.variant_id)||0;
    var totalQty=0;
    for(var i=0;i<cart.items.length;i++){
      var item=cart.items[i];
      if(!itemHasUpgradeMarker(item)) return false;
      if(Number(item.product_id)!==productId || Number(item.variant_id)!==variantId) return false;
      if(bundleTierForItem(item)!==tier) return false;
      totalQty+=Number(item.quantity)||0;
    }
    if(totalQty!==Number(tier.total)) return false;
    return tier.key==='3+3'
      ? cartHasDiscountCode(cart,BUNDLE3_UPGRADE_DISCOUNT_CODE)
      : cartHasDiscountCode(cart,UPGRADE_DISCOUNT_CODE);
  }
  function rebuildBrokenUpgradeAsNormalOffer(cart){
    if(!cart || !Array.isArray(cart.items) || !cart.items.length){
      return Promise.resolve(cart);
    }
    var marked=cart.items.filter(function(item){return itemHasUpgradeMarker(item);});
    if(!marked.length) return Promise.resolve(cart);
    var first=marked[0];
    var productId=Number(first.product_id)||0;
    var variantId=Number(first.variant_id)||0;
    var onlySameEssi=cart.items.every(function(item){
      return Number(item.product_id)===productId &&
        Number(item.variant_id)===variantId &&
        isEssiOfferItem(item);
    });
    /* If something unrelated is also in the cart, never clear it. The price is
       already safe because the upgrade discount was removed before this call. */
    if(!onlySameEssi || !variantId) return Promise.resolve(cart);
    var qty=cart.items.reduce(function(total,item){
      return total+(Number(item.quantity)||0);
    },0);
    if(qty<=0) return Promise.resolve(cart);
    var cleanProps=Object.assign({},first.properties||{});
    delete cleanProps['_Essi upgraded'];
    delete cleanProps['Essi upgraded'];
    delete cleanProps['_Essi discount'];
    var matchingTier=null;
    for(var i=0;i<ESSI_BUNDLE_TIERS.length;i++){
      if(Number(ESSI_BUNDLE_TIERS[i].total)===qty){
        matchingTier=ESSI_BUNDLE_TIERS[i];
        break;
      }
    }
    cleanProps['_Essi offer']=matchingTier
      ? matchingTier.property
      : (qty===1 ? '1 ESSI' : (qty+' ESSI'));
    if(matchingTier && matchingTier.key==='3+3'){
      cleanProps['_Essi discount']=BUNDLE3_DISCOUNT_CODE;
    }
    return postJson(rootPath()+'cart/clear.js',{})
      .then(function(){
        return postJson(rootPath()+'cart/add.js',{
          items:[{id:variantId,quantity:qty,properties:cleanProps}]
        });
      })
      .then(function(){
        return postJson(rootPath()+'cart/update.js',{
          discount:(matchingTier && matchingTier.key==='3+3') ? BUNDLE3_DISCOUNT_CODE : ''
        });
      })
      .then(function(){return loadCartRaw();});
  }
  function sanitizeEssiUpgradeState(cart){
    var hasMarker=cartHasUpgradeMarker(cart);
    var hasUpgradeCode=cartHasAnyEssiUpgradeDiscount(cart);
    if(!hasMarker && !hasUpgradeCode) return Promise.resolve(cart);
    if(upgradedCartStateIsValid(cart)) return Promise.resolve(cart);
    /*
      Invalid/stale upgrade state: remove the EXTRA upgrade discount first.
      This guarantees a remaining single ESSI can never stay at $17.91/$18.xx.
      Then, only when the cart is ESSI-only, rebuild it without the upgrade marker.
    */
    return postJson(rootPath()+'cart/update.js',{discount:''})
      .then(function(){return loadCartRaw();})
      .then(function(cleanCart){return rebuildBrokenUpgradeAsNormalOffer(cleanCart);})
      .then(function(cleanCart){
        clearUpsellAccepted(cleanCart);
        return cleanCart;
      });
  }
  function applyUpgradeDiscountsToCart(targetTier,preDiscountCart){
    // BUNDLE3UP270 REPLACES BUNDLE3X9; never stack the two order codes.
    // Shopify order min ($55) is evaluated on the post-product-discount cart.
    if(targetTier && targetTier.key==='3+3'){
      var unit=getUnitCents(preDiscountCart);
      var before=Number(preDiscountCart && preDiscountCart.total_price)||0;
      var nativeBogo=unit*3; // 6 units, 3 free, $64.47 at $21.49 each.
      var standardBundle=bundle3NormalPriceCents(unit); // $61.47 with old $3 code.
      if(!bundle3UpgradeConfigValid(unit) ||
         before<BUNDLE3_CHECKOUT_MIN_CENTS ||
         (before!==nativeBogo && before!==standardBundle)){
        return Promise.reject(new Error('The 3+3 offer is not eligible for the upgrade price. Please review the current Shopify discounts.'));
      }
    }
    var code=targetTier && targetTier.key==='3+3'
      ? BUNDLE3_UPGRADE_DISCOUNT_CODE
      : UPGRADE_DISCOUNT_CODE;
    return postJson(rootPath()+'cart/update.js',{discount:code});
  }
  function checkoutUrl(cart){
    // Discounts are applied on the live Shopify cart before checkout.
    // Never route through /discount/ and quietly overwrite a verified price.
    return rootPath()+'checkout';
  }
  function syncCheckout(cart){
    if(!checkoutEl) return;
    checkoutEl.textContent='CHECK OUT';
    checkoutEl.setAttribute('href',checkoutUrl(cart));
  }
  function syncAgeGate(){
    if(!checkoutEl || !ageCheckEl) return;
    var allowed=!!ageCheckEl.checked;
    checkoutEl.classList.toggle('is-locked',!allowed);
    if(allowed && ageErrorEl){
      ageErrorEl.hidden=true;
    }
  }
  function getSingleEssiState(cart){
    if(!cart || !cart.items || !cart.items.length) return false;
    var totalSingleQty=0;
    var hasOtherEssiOffer=false;
    cart.items.forEach(function(item){
      if(isSingleEssiItem(item)){
        totalSingleQty+=Number(item.quantity)||0;
      }else if(bundleTierForItem(item)){
        hasOtherEssiOffer=true;
      }
    });
    return !hasOtherEssiOffer && totalSingleQty===1;
  }
  var ESSI_SUBSCRIPTION_TOTALS={
    1:[1790,2790,3390,3890,4390,4890,5390,5990,6590,7190],
    2:[1990,2990,3590,4090,4590,5090,5690,6290,6890,7490],
    4:[2290,3190,3790,4290,4790,5290,5990,6590,7190,7790]
  };
  function subscriptionWeeksForItem(item){
    var label=subscriptionFrequencyLabel(item);
    var match=String(label||'').match(/every\s+(\d+)\s+weeks?/i);
    if(match) return Number(match[1])||0;
    if(/every\s+week/i.test(label) || /weekly/i.test(label)) return 1;
    return 0;
  }
  function renderSubscriptionSmartOffer(cart){
    if(!smartOfferEl) return false;
    if(upsellWasAccepted(cart)) return false;
    var groups=buildCartDisplayGroups(cart).filter(function(group){
      return group.isEssi && group.subscription;
    });
    if(groups.length!==1) return false;
    var group=groups[0];
    var item=group.item;
    var qty=Math.max(1,Math.min(10,Number(group.quantity)||1));
    var weeks=subscriptionWeeksForItem(item);
    var prices=ESSI_SUBSCRIPTION_TOTALS[weeks];
    if(!prices || qty>=10) return false;
    var nextQty=qty+1;
    var currentTotal=prices[qty-1];
    var nextTotal=prices[nextQty-1];
    var extraCents=Math.max(0,nextTotal-currentTotal);
    var nextEach=Math.round(nextTotal/nextQty);
    var totalSave=Math.max(0,(prices[0]*nextQty)-nextTotal);
    var frequency=subscriptionFrequencyLabel(item);
    var dismissKey='subscription-'+weeks+'-'+nextQty;
    if(dismissedUpsellOfferKey===dismissKey) return false;
    smartOfferEl.classList.add('is-subscription-upgrade');
    smartOfferEl.hidden=false;
    smartOfferEl.innerHTML=
      '<button type="button" class="essi-cd__smart-dismiss" data-essi-dismiss-upgrade="'+escapeHtml(dismissKey)+'" aria-label="Dismiss subscription upgrade" title="Close upgrade offer">&times;</button>'+ 
      '<div class="essi-cd__smart-eyebrow">⚡ SUBSCRIPTION UPGRADE</div>'+ 
      '<div class="essi-cd__smart-get">ADD 1 MORE ESSI</div>'+ 
      '<div class="essi-cd__smart-only">ONLY '+money(extraCents)+' MORE / DELIVERY</div>'+ 
      '<div class="essi-cd__smart-total">'+nextQty+' ESSI • '+escapeHtml(frequency)+' • '+money(nextEach)+' / ESSI • '+money(nextTotal)+' / DELIVERY</div>'+ 
      '<div class="essi-cd__smart-chips">'+
        '<span class="essi-cd__smart-chip">FREE SHIPPING</span>'+ 
        '<span class="essi-cd__smart-chip">SAVE '+money(totalSave)+' / DELIVERY</span>'+ 
      '</div>'+ 
      '<button type="button" class="essi-cd__smart-upgrade" data-essi-sub-upgrade="1">UPGRADE TO '+nextQty+' ESSI</button>'+ 
      '<div class="essi-cd__smart-micro">Your delivery schedule stays '+escapeHtml(frequency)+'. Skip or cancel anytime.</div>';
    return true;
  }
  function renderSmartOffer(cart){
    if(!smartOfferEl) return;
    smartOfferEl.classList.remove('is-subscription-upgrade');
    if(cartHasSubscription(cart)){
      if(renderSubscriptionSmartOffer(cart)) return;
      smartOfferEl.hidden=true;
      smartOfferEl.innerHTML='';
      return;
    }
    if(!cart || !cart.items || !cart.items.length){
      dismissedUpsellOfferKey=null;
      smartOfferEl.hidden=true;
      smartOfferEl.innerHTML='';
      return;
    }
    if(cartHasUpgradeMarker(cart)){
      smartOfferEl.hidden=true;
      smartOfferEl.innerHTML='';
      return;
    }
    var currentIndex=currentBundleIndex(cart);
    var currentTier=currentIndex>=0 ? ESSI_BUNDLE_TIERS[currentIndex] : null;
    var nextTier=null;
    var currentTotal=0;
    var currentPayCents=0;
    var unitCents=getUnitCents(cart);
    var baseItem=cart.items.find(function(item){return isEssiOfferItem(item);});
    var essiDisplayGroups=buildCartDisplayGroups(cart).filter(function(group){return group.isEssi;});
    var soleEssiProduct=baseItem && essiDisplayGroups.length===1 && cart.items.every(function(item){
      return isEssiOfferItem(item) &&
        Number(item.product_id)===Number(baseItem.product_id) &&
        Number(item.variant_id)===Number(baseItem.variant_id);
    });
    var eligibleCartCodes=(cart.discount_codes||[]).every(function(code){
      return !code || code.applicable===false ||
        String(code.code||'').toUpperCase()===BUNDLE3_DISCOUNT_CODE;
    });
    if(!soleEssiProduct || !eligibleCartCodes){
      smartOfferEl.hidden=true;
      smartOfferEl.innerHTML='';
      return;
    }
    if(!unitCents){
      smartOfferEl.hidden=true;
      smartOfferEl.innerHTML='';
      return;
    }
    if(getSingleEssiState(cart)){
      nextTier=ESSI_BUNDLE_TIERS[0];
      currentTotal=1;
      currentPayCents=Number(cart.total_price)||unitCents;
    }else if(currentTier){
      nextTier=ESSI_BUNDLE_TIERS[currentIndex+1] || null;
      currentTotal=currentTier.total;
      // Use the CURRENT Shopify charged price, not the undiscounted catalog price.
      currentPayCents=Number(cart.total_price)||
        (currentTier.key==='3+3' ? bundle3NormalPriceCents(unitCents) : unitCents*currentTier.buy);
    }
    // ESSI upgrade card must only quote a price when the current cart matches
    // the expected regular bundle subtotal. This guards against stacking an
    // unrelated automatic/cart discount and advertising a false upgrade delta.
    var expectedCurrentCents=currentTier
      ? (currentTier.key==='3+3'
          ? bundle3NormalPriceCents(unitCents)
          : unitCents*currentTier.buy)
      : unitCents;
    if(!nextTier || dismissedUpsellOfferKey===nextTier.key ||
       (nextTier.key==='3+3' && !bundle3UpgradeConfigValid(unitCents)) ||
       Number(currentPayCents)!==Number(expectedCurrentCents)) {
      // Never show an incorrect special-upgrade price.
      smartOfferEl.hidden=true;
      smartOfferEl.innerHTML='';
      return;
    }
    var extraItems=Math.max(1,nextTier.total-currentTotal);
    // Use live Shopify unit price rather than stale hard-coded bundle amounts.
    // For 3+3 the ordinary offer already includes the $3 BUNDLE3X9 saving;
    // the accepted upgrade adds 10% of THAT displayed ordinary offer amount.
    var nextBundleCents=nextTier.key==='3+3'
      ? bundle3NormalPriceCents(unitCents)
      : unitCents*nextTier.buy;
    var nextAfterUpgradeCents=nextTier.key==='3+3'
      ? bundle3UpgradedPriceCents(unitCents)
      : estimatedPercentUpgradeCents(nextBundleCents);
    var extraCents=Math.max(0,nextAfterUpgradeCents-currentPayCents);
    // Per-extra-item value is only a rounded display figure. Use extraCents as the exact amount due.
    var eachExtraCents=Math.round(extraCents/extraItems);
    var regularNextCents=unitCents*nextTier.total;
    var totalSaveCents=Math.max(0,regularNextCents-nextAfterUpgradeCents);
    smartOfferEl.hidden=false;
    smartOfferEl.innerHTML=
      '<button type="button" class="essi-cd__smart-dismiss" data-essi-dismiss-upgrade="'+escapeHtml(nextTier.key)+'" aria-label="Dismiss upgrade offer" title="Close upgrade offer">&times;</button>'+
      '<div class="essi-cd__smart-eyebrow">⚡ ONE-TAP UPGRADE</div>'+
      '<div class="essi-cd__smart-get">GET '+extraItems+' MORE ESSI</div>'+
      '<div class="essi-cd__smart-only">FOR ONLY '+money(extraCents)+' MORE TOTAL</div>'+
      '<div class="essi-cd__smart-total">≈ '+money(eachExtraCents)+' EACH • '+escapeHtml(nextTier.name)+' • '+nextTier.total+' ESSI TOTAL • '+money(nextAfterUpgradeCents)+' AFTER UPGRADE</div>'+
      '<div class="essi-cd__smart-chips">'+
        '<span class="essi-cd__smart-chip">EXTRA 10% INCLUDED</span>'+
        '<span class="essi-cd__smart-chip">SAVE '+money(totalSaveCents)+'</span>'+
      '</div>'+
      '<button type="button" class="essi-cd__smart-upgrade" data-essi-upgrade-offer="'+escapeHtml(nextTier.key)+'">'+
        'UNLOCK MY UPGRADE'+
      '</button>'+
      '<div class="essi-cd__smart-micro">'+(nextTier.key==='3+3' ? 'Price is verified by Shopify before confirmation.' : '10% upgrade estimate. Final price is verified against Shopify, including cent rounding.')+'</div>';
  }
  function bundleTierByKey(key){
    for(var i=0;i<ESSI_BUNDLE_TIERS.length;i++){
      if(ESSI_BUNDLE_TIERS[i].key===key) return ESSI_BUNDLE_TIERS[i];
    }
    return null;
  }
  function postJson(url,payload){
    return fetch(url,{
      method:'POST',
      headers:{
        'Content-Type':'application/json',
        'Accept':'application/json'
      },
      credentials:'same-origin',
      body:JSON.stringify(payload)
    }).then(function(response){
      return response.json().then(function(data){
        if(!response.ok){
          throw new Error(
            (data && (data.description || data.message))
              ? (data.description || data.message)
              : 'Could not update cart.'
          );
        }
        return data;
      });
    });
  }
  function loadCartRaw(){
    return fetch(rootPath()+'cart.js',{
      method:'GET',
      headers:{'Accept':'application/json'},
      credentials:'same-origin'
    }).then(function(response){
      if(!response.ok) throw new Error('Could not load cart.');
      return response.json();
    });
  }
  function clearOldBundleSafely(cart,productId,variantId){
    // Shopify often splits a BOGO into paid/free lines, which makes their
    // individual line keys unstable. Clear the WHOLE cart ONLY if it contains
    // this one ESSI product and variant; never delete unrelated purchases.
    if(!cart || !Array.isArray(cart.items) || !cart.items.length){
      return Promise.reject(new Error('Your cart is empty.'));
    }
    var onlyThisEssi=cart.items.every(function(item){
      return Number(item.product_id)===Number(productId) &&
        Number(item.variant_id)===Number(variantId);
    });
    if(!onlyThisEssi){
      return Promise.reject(new Error('This upgrade is available for ESSI-only carts. Other items were not changed.'));
    }
    return postJson(rootPath()+'cart/clear.js',{}).then(function(){
      return loadCartRaw();
    }).then(function(fresh){
      if(fresh.item_count!==0 || fresh.items.length){
        throw new Error('The old ESSI bundle was not fully removed. Nothing new was added.');
      }
      return fresh;
    });
  }
  function replaceWithBundleOffer(key,button){
    if(upgradeInProgress) return;
    var nextTier=bundleTierByKey(key);
    if(!nextTier) return;
    upgradeInProgress=true;
    var originalButtonText=button ? button.textContent : 'UNLOCK MY UPGRADE';
    if(button){button.disabled=true;button.textContent='UPGRADING...';}
    drawer.classList.add('is-updating');
    var oldCart=null;
    var oldVariantId=0;
    var oldProductId=0;
    var oldProperties=null;
    var cartWasCleared=false;
    var upgradeConfirmed=false;
    var oldCodes='';
    loadCartRaw().then(function(cart){
      if(cartHasUpgradeMarker(cart) || upsellWasAccepted(cart)){
        throw new Error('This cart has already used the upgrade offer.');
      }
      var baseItem=cart.items.find(isEssiOfferItem);
      if(!baseItem) throw new Error('ESSI item was not found.');
      var currentIndex=currentBundleIndex(cart);
      var requestedIndex=ESSI_BUNDLE_TIERS.findIndex(function(tier){return tier.key===key;});
      var isSingle=getSingleEssiState(cart);
      if(!((isSingle && requestedIndex===0) ||
          (currentIndex>=0 && requestedIndex===currentIndex+1))){
        throw new Error('Your cart changed. Please reopen it to see the available upgrade.');
      }
      oldCart=cart;
      oldVariantId=Number(baseItem.variant_id||baseItem.id);
      oldProductId=Number(baseItem.product_id);
      oldProperties=Object.assign({},baseItem.properties||{});
      if(!oldVariantId || !oldProductId){
        throw new Error('ESSI variant ID is missing.');
      }
      var originalQty=cart.items.reduce(function(total,item){
        return total+(Number(item.quantity)||0);
      },0);
      var expectedQty=isSingle ? 1 : ESSI_BUNDLE_TIERS[currentIndex].total;
      if(originalQty!==expectedQty || cart.items.some(function(item){
        return Number(item.product_id)!==oldProductId || Number(item.variant_id)!==oldVariantId ||
          (isSingle ? !isSingleEssiItem(item) : bundleTierForItem(item)!==ESSI_BUNDLE_TIERS[currentIndex]);
      })){
        throw new Error('The cart contains mixed offers or unexpected quantities. Upgrade stopped without changing them.');
      }
      oldCodes=(cart.discount_codes||[]).filter(function(code){
        return code && code.applicable!==false && code.code;
      }).map(function(code){return code.code;}).join(',');
      if((cart.discount_codes||[]).some(function(code){
        return code && code.applicable!==false &&
          String(code.code||'').toUpperCase()!==BUNDLE3_DISCOUNT_CODE;
      })){
        throw new Error('Your cart has another promotion. Upgrade stopped to avoid overriding it.');
      }
      return clearOldBundleSafely(cart,oldProductId,oldVariantId);
    }).then(function(){
      cartWasCleared=true;
      return postJson(rootPath()+'cart/add.js',{
        items:[{
          id:oldVariantId,
          quantity:nextTier.total,
          properties:{'_Essi offer':nextTier.property,'_Essi upgraded':'1'}
        }]
      });
    }).then(function(){
      return loadCartRaw();
    }).then(function(cart){
      var qty=cart.items.reduce(function(total,item){return total+(Number(item.quantity)||0);},0);
      if(qty!==nextTier.total || cart.items.some(function(item){
        return Number(item.product_id)!==oldProductId || Number(item.variant_id)!==oldVariantId;
      })){
        throw new Error('Shopify did not confirm '+nextTier.total+' ESSI after adding the new offer.');
      }
      return applyUpgradeDiscountsToCart(nextTier,cart);
    }).then(function(){
      return loadCartRaw();
    }).then(function(cart){
      var quantity=cart.items.reduce(function(total,item){
        return total+(Number(item.quantity)||0);
      },0);
      var unitPrice=getUnitCents(cart);
      var paidBeforeCodes=unitPrice*nextTier.buy;
      var expected=nextTier.key==='3+3'
        ? bundle3UpgradedPriceCents(unitPrice)
        : estimatedPercentUpgradeCents(paidBeforeCodes);
      var verifiedPrice=upgradeCartPriceMatchesShopify(nextTier,unitPrice,cart.total_price);
      var correctLines=quantity===nextTier.total && cart.items.every(function(item){
        return Number(item.product_id)===oldProductId &&
          Number(item.variant_id)===oldVariantId &&
          offerMatchesTier(offerProperty(item),nextTier) && itemHasUpgradeMarker(item);
      });
      var correctCodes=nextTier.key==='3+3'
        ? cartHasDiscountCode(cart,BUNDLE3_UPGRADE_DISCOUNT_CODE)
        : cartHasDiscountCode(cart,UPGRADE_DISCOUNT_CODE);
      if(!correctLines || !correctCodes || !verifiedPrice){
        throw new Error('Shopify did not confirm the upgrade price. Expected around '+
          money(expected)+' for '+nextTier.total+' ESSI with the correct discount, but the cart shows '+
          quantity+' ESSI for '+money(cart.total_price)+'.');
      }
      // The actual Shopify cart total, not the storefront estimate, wins.
      // render(cart) below displays that verified real amount.
      upgradeConfirmed=true;
      markUpsellAccepted(cart);
      render(cart);
      document.dispatchEvent(new CustomEvent('essi:cart:updated',{detail:cart}));
    }).catch(function(error){
      console.error('ESSI upgrade error:',error);
      if(!cartWasCleared || upgradeConfirmed || !oldCart){
        alert(error.message||'Could not upgrade your offer.');
        return loadCartRaw().then(render).catch(function(){ /* show original error */ });
      }
      // A failed discount must not leave the shopper on a different offer.
      // Best-effort recovery of the original ESSI-only cart and its codes.
      var previousQuantity=oldCart.items.reduce(function(total,item){
        return total+(Number(item.quantity)||0);
      },0);
      return postJson(rootPath()+'cart/clear.js',{}).then(function(){
        return postJson(rootPath()+'cart/add.js',{
          items:[{id:oldVariantId,quantity:previousQuantity,properties:oldProperties}]
        });
      }).then(function(){
        return postJson(rootPath()+'cart/update.js',{discount:oldCodes});
      }).then(function(){
        return loadCartRaw();
      }).then(function(recovered){
        render(recovered);
        alert((error.message||'Upgrade was not completed.')+' Your previous offer was restored.');
      }).catch(function(recoveryError){
        console.error('ESSI recovery error:',recoveryError);
        alert('The upgrade could not be completed and we could not restore your previous cart automatically. Please reselect your ESSI offer before checkout.');
        return loadCartRaw().then(render).catch(function(){});
      });
    }).finally(function(){
      upgradeInProgress=false;
      drawer.classList.remove('is-updating');
      if(button && document.body.contains(button)){
        button.disabled=false;
        button.textContent=originalButtonText;
      }
    });
  }
  function buildCartDisplayGroups(cart){
    var groups=[];
    var groupMap={};
    var items=(cart && Array.isArray(cart.items)) ? cart.items : [];
    items.forEach(function(item,index){
      var isEssi=isEssiOfferItem(item);
      if(!isEssi){
        groups.push({
          isEssi:false,
          item:item,
          items:[item],
          quantity:Number(item.quantity)||0,
          firstLine:index+1
        });
        return;
      }
      var offer=offerProperty(item);
      var sellingPlanId=itemSellingPlanId(item);
      var key=[
        Number(item.product_id)||0,
        Number(item.variant_id)||0,
        normalizeOffer(offer),
        sellingPlanId,
        itemHasUpgradeMarker(item) ? 'upgraded' : 'normal'
      ].join('|');
      if(!groupMap[key]){
        groupMap[key]={
          isEssi:true,
          item:item,
          items:[],
          quantity:0,
          firstLine:index+1,
          productId:Number(item.product_id)||0,
          variantId:Number(item.variant_id)||0,
          offer:offer,
          upgraded:itemHasUpgradeMarker(item),
          subscription:sellingPlanId>0,
          sellingPlanId:sellingPlanId,
          sellingPlanName:subscriptionPlanName(item)
        };
        groupMap[key].groupIndex=groups.length;
        groups.push(groupMap[key]);
      }
      groupMap[key].items.push(item);
      groupMap[key].quantity+=Number(item.quantity)||0;
    });
    return groups;
  }
  function groupLineValue(group,field,fallbackField){
    var total=0;
    (group.items||[]).forEach(function(item){
      var value=(typeof item[field]==='number') ? item[field] : item[fallbackField];
      total+=Math.max(0,Number(value)||0);
    });
    return total;
  }
  function essiGroupOfferState(group){
    if(!group || !group.item){
      return {paid:1,free:0,total:1,tier:null};
    }
    var tier=bundleTierForItem(group.item);
    if(tier){
      return {paid:tier.buy,free:tier.free,total:tier.total,tier:tier};
    }
    if(isSingleEssiItem(group.item)){
      return {paid:1,free:0,total:1,tier:null};
    }
    return {paid:Math.max(1,Number(group.quantity)||1),free:0,total:Math.max(1,Number(group.quantity)||1),tier:null};
  }
  function essiTargetForPaidCount(paidCount){
    var paid=Math.max(0,Math.min(5,Number(paidCount)||0));
    if(paid<=0){
      return {paid:0,free:0,total:0,tier:null,offer:''};
    }
    if(paid===1){
      return {paid:1,free:0,total:1,tier:null,offer:'1 ESSI'};
    }
    var tier=ESSI_BUNDLE_TIERS[paid-2] || null;
    if(!tier){
      return {paid:1,free:0,total:1,tier:null,offer:'1 ESSI'};
    }
    return {paid:tier.buy,free:tier.free,total:tier.total,tier:tier,offer:tier.property};
  }
  function activeCartDiscountCodes(cart){
    return (cart && Array.isArray(cart.discount_codes) ? cart.discount_codes : [])
      .filter(function(code){return code && code.applicable!==false && code.code;})
      .map(function(code){return String(code.code);});
  }
  function nonEssiDiscountCodes(cart){
    var blocked=[
      UPGRADE_DISCOUNT_CODE,
      BUNDLE3_DISCOUNT_CODE,
      BUNDLE3_UPGRADE_DISCOUNT_CODE
    ].map(function(code){return String(code).toUpperCase();});
    return activeCartDiscountCodes(cart).filter(function(code){
      return blocked.indexOf(String(code).toUpperCase())===-1;
    });
  }
  function itemMatchesEssiGroup(item,productId,variantId,offer,sellingPlanId){
    return Number(item.product_id)===Number(productId) &&
      Number(item.variant_id)===Number(variantId) &&
      normalizeOffer(offerProperty(item))===normalizeOffer(offer) &&
      itemSellingPlanId(item)===Number(sellingPlanId||0);
  }
  function replaceEssiGroupPaidQuantity(productId,variantId,offer,newPaidCount,sellingPlanId){
    if(Number(sellingPlanId||0)>0){
      return Promise.reject(new Error('Subscription bundle quantity is fixed. Change the subscription tier from the product page.'));
    }
    if(upgradeInProgress) return Promise.resolve();
    var target=essiTargetForPaidCount(newPaidCount);
    drawer.classList.add('is-updating');
    var originalCart=null;
    var originalProps=null;
    var preservedCodes=[];
    return loadCartRaw().then(function(cart){
      originalCart=cart;
      var matching=cart.items.filter(function(item){
        return itemMatchesEssiGroup(item,productId,variantId,offer,sellingPlanId);
      });
      if(!matching.length){
        throw new Error('This ESSI offer changed. Please reopen the cart and try again.');
      }
      originalProps=Object.assign({},matching[0].properties||{});
      preservedCodes=nonEssiDiscountCodes(cart);
      /* Manual +/- changes leave the special one-tap upgrade.
         Clear upgrade/bundle codes first so a remaining single can NEVER inherit
         a cheaper bundle price. */
      return postJson(rootPath()+'cart/update.js',{discount:preservedCodes.join(',')});
    }).then(function(){
      return loadCartRaw();
    }).then(function(cart){
      var updates=cart.items.map(function(item){
        return itemMatchesEssiGroup(item,productId,variantId,offer,sellingPlanId) ? 0 : (Number(item.quantity)||0);
      });
      return postJson(rootPath()+'cart/update.js',{updates:updates});
    }).then(function(){
      if(target.total<=0) return null;
      var props=Object.assign({},originalProps||{});
      delete props['_Essi upgraded'];
      delete props['Essi upgraded'];
      delete props['_Essi discount'];
      delete props['Essi discount'];
      delete props['_Essi offer'];
      delete props['Essi offer'];
      props['_Essi offer']=target.offer;
      if(target.tier && target.tier.key==='3+3'){
        props['_Essi discount']=BUNDLE3_DISCOUNT_CODE;
      }
      return postJson(rootPath()+'cart/add.js',{
        items:[{id:Number(variantId),quantity:target.total,properties:props}]
      });
    }).then(function(){
      var nextCodes=preservedCodes.slice();
      if(target.tier && target.tier.key==='3+3'){
        nextCodes.push(BUNDLE3_DISCOUNT_CODE);
      }
      return postJson(rootPath()+'cart/update.js',{discount:nextCodes.join(',')});
    }).then(function(){
      return loadCartRaw();
    }).then(function(cart){
      clearUpsellAccepted(originalCart||cart);
      dismissedUpsellOfferKey=null;
      render(cart);
      document.dispatchEvent(new CustomEvent('essi:cart:updated',{detail:cart}));
      return cart;
    }).catch(function(error){
      console.error('ESSI quantity change error:',error);
      alert(error.message||'Could not update your ESSI quantity.');
      return loadCartRaw().then(render).catch(function(){});
    }).finally(function(){
      drawer.classList.remove('is-updating');
    });
  }
  function removeEssiOfferGroup(productId,variantId,offer,sellingPlanId){
    drawer.classList.add('is-updating');
    var firstCart=null;
    var preservedCodes=[];
    return loadCartRaw().then(function(cart){
      firstCart=cart;
      preservedCodes=nonEssiDiscountCodes(cart);
      return postJson(rootPath()+'cart/update.js',{discount:preservedCodes.join(',')});
    }).then(function(){
      return loadCartRaw();
    }).then(function(cart){
      var found=false;
      var updates=cart.items.map(function(item){
        if(itemMatchesEssiGroup(item,productId,variantId,offer,sellingPlanId)){
          found=true;
          return 0;
        }
        return Number(item.quantity)||0;
      });
      if(!found) return cart;
      return postJson(rootPath()+'cart/update.js',{updates:updates})
        .then(function(){return loadCartRaw();});
    }).then(function(cart){
      clearUpsellAccepted(firstCart||cart);
      dismissedUpsellOfferKey=null;
      render(cart);
      document.dispatchEvent(new CustomEvent('essi:cart:updated',{detail:cart}));
      return cart;
    }).catch(function(error){
      console.error('ESSI remove error:',error);
      alert(error.message||'Could not remove the ESSI offer.');
      return loadCartRaw().then(render).catch(function(){});
    }).finally(function(){
      drawer.classList.remove('is-updating');
    });
  }
  function render(cart){
    window.__essi_last_cart=cart;
    var count=cart && cart.item_count ? cart.item_count : 0;
    titleEl.textContent='Cart • '+count+' '+(count===1?'item':'items');
    updateHeaderCartBadge(cart);
    var subtotal=cart.total_price || 0;
    var cartLinesBeforeOrderDiscounts=0;
    if(cart.items && cart.items.length){
      cart.items.forEach(function(item){
        var actualLine=(typeof item.final_line_price==='number') ? item.final_line_price : item.line_price;
        cartLinesBeforeOrderDiscounts+=Math.max(0,Number(actualLine)||0);
      });
    }
    /*
      IMPORTANT:
      Shopify cart.total_price already includes active order-level discounts
      such as UPGRADE10 / BUNDLE3X9. Do NOT multiply the subtotal by 0.90 again.
    */
    var cartLevelSavings=Math.max(
      0,
      cartLinesBeforeOrderDiscounts-(Number(cart.total_price)||0)
    );
    var displaySubtotal=Math.max(0,subtotal);
var upgradeDiscountActive=
      cartHasUpgradeMarker(cart) &&
      (cartHasDiscountCode(cart,UPGRADE_DISCOUNT_CODE) ||
       cartHasDiscountCode(cart,BUNDLE3_UPGRADE_DISCOUNT_CODE));
    subtotalEl.textContent=money(displaySubtotal);
    var remaining=0;
    var shippingCost=0;
    var estimatedTotal=displaySubtotal + shippingCost;
    if(remaining<=0){
      shippingText.textContent="FREE SHIPPING ON ALL ORDERS";
      if(shippingPriceEl) shippingPriceEl.textContent='FREE';
    }else{
      shippingText.textContent='Add '+money(remaining)+' more for FREE SHIPPING';
      if(shippingPriceEl) shippingPriceEl.textContent=money(STANDARD_SHIPPING_CENTS);
    }
    if(estimatedTotalEl){
      estimatedTotalEl.textContent=money(estimatedTotal);
    }
    if(!cart.items || !cart.items.length){
      clearUpsellAccepted(cart);
      renderSmartOffer(cart);
      syncCheckout(cart);
      syncAgeGate();
      itemsWrap.innerHTML=
        '<div class="essi-cd__empty">'+
          '<strong>Your cart is empty</strong>'+
          '<span>Choose your Essi and come back here.</span>'+
          '<button type="button" data-essi-cart-close>SHOP ESSI</button>'+
        '</div>';
      bindCloseButtons();
      return;
    }
    renderSmartOffer(cart);
    syncCheckout(cart);
    syncAgeGate();
    var html='';
    var displayGroups=buildCartDisplayGroups(cart);
    displayGroups.forEach(function(group,groupIndex){
      var item=group.item;
      var image=itemImage(item);
      var variant=(item.variant_title && item.variant_title!=='Default Title') ? item.variant_title : '';
      var offer=group.isEssi ? group.offer : offerProperty(item);
      var essiState=group.isEssi ? essiGroupOfferState(group) : null;
      var finalLine=group.isEssi
        ? groupLineValue(group,'final_line_price','line_price')
        : ((typeof item.final_line_price==='number') ? item.final_line_price : item.line_price);
      var originalLine=group.isEssi
        ? groupLineValue(group,'original_line_price','line_price')
        : ((typeof item.original_line_price==='number') ? item.original_line_price : item.line_price);
      var hasDiscount=originalLine>finalLine;
      var displayLine=finalLine;
      var displayCompare=originalLine;
      /* Allocate Shopify's real cart-level discount to this visual group. */
      if(
        cartLevelSavings>0 &&
        finalLine>0 &&
        cartLinesBeforeOrderDiscounts>0 &&
        (
          !cartHasDiscountCode(cart,UPGRADE_DISCOUNT_CODE) ||
          (group.isEssi ? group.upgraded : itemHasUpgradeMarker(item))
        )
      ){
        var lineShare=finalLine/cartLinesBeforeOrderDiscounts;
        var lineCartDiscount=Math.round(cartLevelSavings*lineShare);
        displayLine=Math.max(0,finalLine-lineCartDiscount);
        /* For a BOGO group, show what the customer paid before the extra upgrade
           code, not a misleading duplicate/free split line. */
        displayCompare=finalLine;
        hasDiscount=displayCompare>displayLine;
      }
      if(group.isEssi && group.subscription && essiState){
        var catalogUnit=Math.max(Number(item.original_price)||0,1990);
        var oneTimeBundle=essiState.tier
          ? (essiState.tier.key==='3+3' ? bundle3NormalPriceCents(catalogUnit) : catalogUnit*essiState.tier.buy)
          : catalogUnit;
        displayCompare=oneTimeBundle;
        hasDiscount=displayCompare>displayLine;
      }

      /* ONE-TIME ESSI RETAIL VALUE
         The crossed-out price must represent the FULL regular retail value of
         every ESSI the customer receives — not Shopify's paid-item/BOGO subtotal.

         Example for BUY 3 + GET 3 FREE at $21.49 per ESSI:
         6 ESSI × $21.49 = $128.94 regular value
         Normal offer = $61.47, upgraded = $55.32
         Total saving at upgrade = $73.62
      */
      if(group.isEssi && !group.subscription && essiState){
        var regularUnitCents=Math.max(
          Number(item.original_price)||0,
          Number(item.price)||0,
          Number(item.final_price)||0,
          1990
        );
        var totalEssiReceived=Math.max(
          1,
          Number(essiState.total)||Number(group.quantity)||1
        );
        displayCompare=regularUnitCents*totalEssiReceived;
        hasDiscount=displayCompare>displayLine;
      }
      var firstOrderPromoActive=!!(
        group.isEssi &&
        !group.subscription &&
        essiState &&
        !essiState.tier &&
        Number(group.quantity)===1 &&
        Number(displayLine)===1490
      );
      var articleAttrs=' class="essi-cd__item" data-line="'+group.firstLine+'"';
      if(group.isEssi){
        articleAttrs+=' data-essi-group="1"'+
          ' data-product-id="'+escapeHtml(group.productId)+'"'+
          ' data-variant-id="'+escapeHtml(group.variantId)+'"'+
          ' data-offer="'+escapeHtml(group.offer)+'"'+
          ' data-selling-plan-id="'+escapeHtml(group.sellingPlanId||0)+'"'+
          ' data-subscription="'+(group.subscription?'1':'0')+'"';
      }
      html+='<article'+articleAttrs+'>';
      html+='<div class="essi-cd__image">';
      if(image){
        html+='<img src="'+escapeHtml(image)+'" alt="'+escapeHtml(item.product_title || item.title || 'Essi')+'" loading="lazy">';
      }
      html+='</div>';
      html+='<div class="essi-cd__info">';
      html+='<h3 class="essi-cd__product-title">'+escapeHtml(item.product_title || item.title || 'Essi')+'</h3>';
      if(variant) html+='<p class="essi-cd__variant">'+escapeHtml(variant)+'</p>';
      if(offer) html+='<span class="essi-cd__property">'+escapeHtml(offer)+'</span>';
      if(firstOrderPromoActive){
        html+='<div class="essi-cd__first-order-meta">';
        html+='<strong>NEW CUSTOMER OFFER</strong>';
        html+='<span>First order only • Limit 1 • Applied automatically at checkout</span>';
        html+='</div>';
      }
      if(group.isEssi && group.subscription){
        var subFrequency=subscriptionFrequencyLabel(item);
        html+='<div class="essi-cd__subscription-meta">';
        html+='<strong>SUBSCRIBE &amp; SAVE</strong>';
        html+='<b>SUBSCRIPTION • '+escapeHtml(subFrequency.toUpperCase())+'</b>';
        html+='<span>Renews automatically • FREE SHIPPING • Skip or cancel anytime</span>';
        html+='</div>';
      }
      if(group.isEssi){
        if(group.subscription){
          html+='<div class="essi-cd__qty-wrap"><div class="essi-cd__qty">';
          html+='<button type="button" data-essi-sub-qty-change="-1"'+(group.quantity<=1?' disabled':'')+'>−</button>';
          html+='<span>'+escapeHtml(group.quantity)+'</span>';
          html+='<button type="button" data-essi-sub-qty-change="1"'+(group.quantity>=10?' disabled':'')+'>+</button>';
          html+='</div></div>';
        }
        if(!group.subscription){
          /* One-time ESSI offers are fixed bundles. Do not show +/- controls because
             changing the paid quantity can break the selected BOGO offer. */
          var oneTimeCatalogUnit=Math.max(
            Number(item.original_price)||0,
            Number(item.price)||0,
            Number(item.final_price)||0,
            1990
          );
          var oneTimeTotalReceived=Math.max(
            1,
            Number(essiState && essiState.total)||Number(group.quantity)||1
          );
          var oneTimeRegularTotal=Math.max(0,oneTimeCatalogUnit*oneTimeTotalReceived);
          var oneTimeSave=Math.max(0,oneTimeRegularTotal-Number(displayLine||0));
          var oneTimeHeadline='';
          var oneTimeSubtext='';

          if(essiState && essiState.free>0){
            oneTimeHeadline=(essiState.total || group.quantity)+' ESSI TOTAL';
            oneTimeSubtext='BUY '+essiState.paid+' + GET '+essiState.free+' FREE';
          }else{
            oneTimeHeadline=(group.quantity || 1)+' ESSI';
            oneTimeSubtext='ONE-TIME PURCHASE';
          }

          html+='<div class="essi-cd__qty-wrap">';
          html+='<div class="essi-cd__fixed-offer">';
          html+='<div class="essi-cd__fixed-offer-top">';
          html+='<strong class="essi-cd__fixed-offer-headline">'+escapeHtml(oneTimeHeadline)+'</strong>';
          html+='<span class="essi-cd__fixed-offer-subtext">'+escapeHtml(oneTimeSubtext)+'</span>';
          html+='</div>';
          if(oneTimeSave>0){
            html+='<div class="essi-cd__fixed-offer-save">';
            html+='<span class="essi-cd__fixed-offer-save-label">YOU SAVE</span>';
            html+='<strong class="essi-cd__fixed-offer-save-value">'+money(oneTimeSave)+'</strong>';
            html+='</div>';
          }
          html+='</div>';
          html+='</div>';
        }
      }else{
        html+='<div class="essi-cd__qty">';
        html+='<button type="button" data-essi-cart-qty="-1" aria-label="Decrease quantity">−</button>';
        html+='<span>'+escapeHtml(group.quantity)+'</span>';
        html+='<button type="button" data-essi-cart-qty="1" aria-label="Increase quantity">+</button>';
        html+='</div>';
      }
      html+='</div>';
      html+='<div class="essi-cd__right">';
      html+='<button type="button" class="essi-cd__remove" data-essi-cart-remove aria-label="Remove item">';
      html+='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 7h14M9 7V4h6v3M8 10l.7 9h6.6l.7-9M10.5 11.5v5M13.5 11.5v5"></path></svg>';
      html+='</button>';
      html+='<div class="essi-cd__prices">';
      html+='<strong class="essi-cd__price">'+money(displayLine)+'</strong>';
      if(hasDiscount){
        html+='<span class="essi-cd__compare">'+money(displayCompare)+'</span>';
      }
      if(group.isEssi && group.subscription){
        html+='<span class="essi-cd__subscription-delivery-label">PER DELIVERY</span>';
      }
      html+='</div>';
      html+='</div>';
      if(
        upgradeDiscountActive &&
        group.isEssi &&
        group.upgraded &&
        finalLine>0
      ){
        html+='<div class="essi-cd__upgrade-note"><strong>YOUR EXTRA 10% UPGRADE SAVING IS INCLUDED</strong></div>';
      }
      if(group.isEssi && essiState && essiState.free>0){
        html+='<div class="essi-cd__free-line">';
        html+='<div class="essi-cd__free-line-image">';
        if(image){
          html+='<img src="'+escapeHtml(image)+'" alt="Free Essi" loading="lazy">';
        }
        html+='</div>';
        html+='<div class="essi-cd__free-line-copy">';
        html+='<strong>+ '+escapeHtml(essiState.free)+' FREE ESSI'+(essiState.free===1?'':'')+'</strong>';
        html+='<span>Included automatically with this offer</span>';
        html+='</div>';
        html+='<strong class="essi-cd__free-price">FREE</strong>';
        html+='</div>';
      }
      html+='</article>';
    });
    itemsWrap.innerHTML=html;
  }
  function fetchCart(){
    return fetch(rootPath()+'cart.js',{
      method:'GET',
      headers:{'Accept':'application/json'},
      credentials:'same-origin'
    }).then(function(response){
      if(!response.ok) throw new Error('Could not load cart.');
      return response.json();
    }).then(function(cart){
      /*
        Never auto-apply UPGRADE10 while simply opening the cart.
        UPGRADE10 is applied ONLY after the shopper presses
        UNLOCK MY UPGRADE.
      */
      return sanitizeEssiUpgradeState(cart);
    }).then(function(cart){
      render(cart);
      return cart;
    });
  }
  async function adjustEssiSubscription(itemNode,delta,fromSmartUpgrade){
    var variantId=Number(itemNode.dataset.variantId||0);
    var oldPlan=Number(itemNode.dataset.sellingPlanId||0);
    var currentQty=Number(itemNode.querySelector('.essi-cd__qty span')?.textContent||0);
    var nextQty=currentQty+delta;
    if(nextQty<1||nextQty>10||!variantId)return;
    var cart=await loadCartRaw();
    var oldItems=cart.items.filter(i=>Number(i.variant_id)===variantId&&itemSellingPlanId(i)===oldPlan);
    var oldItem=oldItems[0];
    var label=oldItem?subscriptionFrequencyLabel(oldItem):'';
    var weekMatch=label.match(/every (\d+) week/i);
    var weeks=weekMatch?Number(weekMatch[1]):(/week/i.test(label)?1:0);
    var nextPlan=(window.EssiSubscriptionPlans||{})[nextQty+'-'+weeks];
    if(!nextPlan){alert('Please open the ESSI product page to change subscription quantity.');return}
    drawer.classList.add('is-updating');
    try{
      // Remove old subscription lines, then add the correct selling plan and quantity.
      for(var i=0;i<oldItems.length;i++){
        var response=await fetch(rootPath()+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:oldItems[i].key,quantity:0})});
        if(!response.ok)throw Error('Could not remove previous subscription tier');
      }
      var added=await fetch(rootPath()+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:variantId,quantity:nextQty,selling_plan:nextPlan.id,properties:{'_Essi offer':nextQty+' ESSI Subscription','_Essi purchase type':'Subscription','_Essi delivery':weeks===1?'Every week':'Every '+weeks+' weeks'}}]})});
      if(!added.ok)throw Error('Could not add the updated subscription tier');
      if(fromSmartUpgrade){
        var upgradedCart=await loadCartRaw();
        markUpsellAccepted(upgradedCart);
        render(upgradedCart);
        document.dispatchEvent(new CustomEvent('essi:cart:updated',{detail:upgradedCart}));
      }else{
        await fetchCart();
      }
    }catch(e){alert(e.message||'Subscription update failed. Please check your cart.');await fetchCart()}
    finally{drawer.classList.remove('is-updating')}
  }
  function changeLine(line,quantity){
    drawer.classList.add('is-updating');
    return fetch(rootPath()+'cart/change.js',{
      method:'POST',
      headers:{
        'Content-Type':'application/json',
        'Accept':'application/json'
      },
      credentials:'same-origin',
      body:JSON.stringify({
        line:line,
        quantity:Math.max(0,quantity)
      })
    }).then(function(response){
      return response.json().then(function(data){
        if(!response.ok){
          throw new Error(data.description || data.message || 'Could not update cart.');
        }
        return data;
      });
    }).then(function(cart){
      return sanitizeEssiUpgradeState(cart);
    }).then(function(cart){
      render(cart);
      document.dispatchEvent(new CustomEvent('essi:cart:updated',{detail:cart}));
      return cart;
    }).catch(function(error){
      alert(error.message || 'Could not update cart.');
      return fetchCart();
    }).finally(function(){
      drawer.classList.remove('is-updating');
    });
  }
  function bindCloseButtons(){
    drawer.querySelectorAll('[data-essi-cart-close]').forEach(function(button){
      if(button.dataset.essiBound==='1') return;
      button.dataset.essiBound='1';
      button.addEventListener('click',close);
    });
  }
  function open(){
    overlay.hidden=false;
    requestAnimationFrame(function(){
      overlay.classList.add('is-open');
      drawer.classList.add('is-open');
    });
    drawer.setAttribute('aria-hidden','false');
    document.body.classList.add('essi-cd-lock');
    startTimer();
    fetchCart().catch(function(){
      itemsWrap.innerHTML='<div class="essi-cd__empty"><strong>Could not load cart</strong><span>Please try again.</span></div>';
    });
  }
  function close(){
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true');
    document.body.classList.remove('essi-cd-lock');
    setTimeout(function(){
      if(!drawer.classList.contains('is-open')) overlay.hidden=true;
    },260);
  }
  function startTimer(){
    var key='essiCartReserveUntil';
    var now=Date.now();
    var until=parseInt(sessionStorage.getItem(key)||'0',10);
    if(!until || until<=now){
      until=now+(5*60*1000);
      sessionStorage.setItem(key,String(until));
    }
    if(timerId) clearInterval(timerId);
    function tick(){
      var left=Math.max(0,until-Date.now());
      var seconds=Math.ceil(left/1000);
      var mins=Math.floor(seconds/60);
      var secs=seconds%60;
      timerEl.textContent=String(mins).padStart(2,'0')+':'+String(secs).padStart(2,'0');
      if(left<=0){
        clearInterval(timerId);
        timerId=null;
      }
    }
    tick();
    timerId=setInterval(tick,1000);
  }
  overlay.addEventListener('click',close);
  bindCloseButtons();
  if(ageCheckEl){
    ageCheckEl.addEventListener('change',syncAgeGate);
  }
  document.addEventListener('click',function(event){
    var opener=event.target.closest('[data-essi-cart-open]');
    if(opener){
      event.preventDefault();
      open();
      return;
    }
    var checkoutBtn=event.target.closest('[data-essi-cart-checkout]');
    if(checkoutBtn && drawer.contains(checkoutBtn)){
      if(upgradeInProgress){
        event.preventDefault();
        return;
      }
      if(!ageCheckEl || !ageCheckEl.checked){
        event.preventDefault();
        if(ageErrorEl) ageErrorEl.hidden=false;
        if(ageCheckEl) ageCheckEl.focus();
        return;
      }
    }
    var dismissBtn=event.target.closest('[data-essi-dismiss-upgrade]');
    if(dismissBtn && drawer.contains(dismissBtn)){
      event.preventDefault();
      dismissedUpsellOfferKey=dismissBtn.getAttribute('data-essi-dismiss-upgrade')||null;
      smartOfferEl.hidden=true;
      smartOfferEl.innerHTML='';
      return;
    }
    var upgradeBtn=event.target.closest('[data-essi-upgrade-offer]');
    if(upgradeBtn && drawer.contains(upgradeBtn)){
      event.preventDefault();
      var upgradeKey=upgradeBtn.getAttribute('data-essi-upgrade-offer')||'';
      if(upgradeKey){
        replaceWithBundleOffer(upgradeKey,upgradeBtn);
      }
      return;
    }
    var subUpgradeBtn=event.target.closest('[data-essi-sub-upgrade]');
    if(subUpgradeBtn && drawer.contains(subUpgradeBtn)){
      event.preventDefault();
      var subscriptionItem=drawer.querySelector('[data-essi-group="1"][data-subscription="1"]');
      if(subscriptionItem){
        subUpgradeBtn.disabled=true;
        subUpgradeBtn.textContent='UPGRADING…';
        adjustEssiSubscription(subscriptionItem,1,true);
      }
      return;
    }
    var subBtn=event.target.closest('[data-essi-sub-qty-change]');
    if(subBtn&&drawer.contains(subBtn)){
      var subNode=subBtn.closest('[data-line]');
      if(subNode)adjustEssiSubscription(subNode,Number(subBtn.dataset.essiSubQtyChange));
      return;
    }
    var qtyBtn=event.target.closest('[data-essi-cart-qty]');
    if(qtyBtn && drawer.contains(qtyBtn)){
      if(qtyBtn.disabled) return;
      var item=qtyBtn.closest('[data-line]');
      if(!item) return;
      /* One-time ESSI bundle quantities are fixed in the cart. Subscription controls
         use data-essi-sub-qty-change and are intentionally unaffected. */
      if(item.getAttribute('data-essi-group')==='1') return;
      var delta=parseInt(qtyBtn.getAttribute('data-essi-cart-qty')||'0',10);
      var currentEl=item.querySelector('.essi-cd__qty span');
      var current=parseInt(currentEl ? currentEl.textContent : '1',10);
      if(item.getAttribute('data-essi-group')==='1'){
        var productId=parseInt(item.getAttribute('data-product-id')||'0',10);
        var variantId=parseInt(item.getAttribute('data-variant-id')||'0',10);
        var offer=item.getAttribute('data-offer')||'';
        var sellingPlanId=parseInt(item.getAttribute('data-selling-plan-id')||'0',10);
        if(item.getAttribute('data-subscription')==='1') return;
        if(productId && variantId){
          replaceEssiGroupPaidQuantity(productId,variantId,offer,current+delta,sellingPlanId);
        }
        return;
      }
      var line=parseInt(item.getAttribute('data-line')||'0',10);
      if(line) changeLine(line,current+delta);
      return;
    }
    var removeBtn=event.target.closest('[data-essi-cart-remove]');
    if(removeBtn && drawer.contains(removeBtn)){
      var removeItem=removeBtn.closest('[data-line]');
      if(!removeItem) return;
      if(removeItem.getAttribute('data-essi-group')==='1'){
        var productId=parseInt(removeItem.getAttribute('data-product-id')||'0',10);
        var variantId=parseInt(removeItem.getAttribute('data-variant-id')||'0',10);
        var offer=removeItem.getAttribute('data-offer')||'';
        var sellingPlanId=parseInt(removeItem.getAttribute('data-selling-plan-id')||'0',10);
        if(productId && variantId){
          removeEssiOfferGroup(productId,variantId,offer,sellingPlanId);
        }
        return;
      }
      var removeLine=parseInt(removeItem.getAttribute('data-line')||'0',10);
      if(removeLine) changeLine(removeLine,0);
    }
  });
  document.addEventListener('keydown',function(event){
    if(event.key==='Escape' && drawer.classList.contains('is-open')) close();
  });
  // Initialize on page load; stay in sync with additions, removals and upsells.
  refreshHeaderCartBadge();
  document.addEventListener('essi:cart:updated',function(event){
    if(event.detail && typeof event.detail.item_count==='number'){
      updateHeaderCartBadge(event.detail);
    }else{
      refreshHeaderCartBadge();
    }
  });
  document.addEventListener('visibilitychange',function(){
    if(!document.hidden) refreshHeaderCartBadge();
  });
  window.addEventListener('pageshow',refreshHeaderCartBadge);
  document.addEventListener('essi:cart:open',open);
  document.addEventListener('essi:cart:refresh',fetchCart);
  window.EssiCartDrawer={
    __ready:true,
    buildVersion:'ESSI-2149-915-20261022-V2',
    open:open,
    close:close,
    refresh:fetchCart
  };
})();
  } catch(e) { console.error(e); }
})();

})();
